function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.4 191.4v-29.6l34.2-34.2h29.6v43.2l28.3-28.3V92.2h50.4l28.4-28.4H92.1v35.5H50.8L0 150.1v69.6h21.1c0 6.3 1.4 12.4 4.2 18l46.3-46.3H28.4zM239.5 63.8l-28.4 28.4h44v99.2H120.5v-8.5l-71.8 71.8c2.5.4 5 .7 7.5.7 21.6 0 35.8-14.7 35.8-35.6h99.3c.2 21.4 14.3 35.5 35.1 35.5 21.6 0 35.8-14.6 35.8-35.5h21.3v-156h-44zM10.4 262.9l10.7 9.9L276.3 17 266 6.9z"
})));